import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import '../assets/css/libs.css'
import '../assets/css/style.css'
import { useDescription } from '../hook/useDescription'
import { useHeadTitle } from '../hook/useHeadTitle'
import { useSendEmbedSizeInfo } from '../hook/useSendEmbedHeight'
import { AppState } from '../store'
import { reset } from '../store/modules/calcReversal'
import { CalcReversalChart } from './CalcReversalChart'
import { CalcReversalErrorModal } from './CalcReversalErrorModal'
import { CalcReversalForm } from './CalcReversalForm'
import { CalcReversalGuideModal } from './CalcReversalGuideModal'
import { DisclaimerModal } from './DisclaimerModal'
import { Loading } from './Loading'

export interface FormInput {
  initial: number
  addition: number
  interest1: number
  interest2: number
  startAge: number
  turningAddition?: number
  turningAge?: number
}

export const defaultValues = {
  initial: 2444,
  addition: 8,
  interest1: 0.1,
  interest2: 3.0,
  startAge: 65,
  turningAddition: 8,
  turningAge: 70,
}

export const constraintValues = {
  initial: {
    upper: 99999.9,
    lower: 0,
    decimalPoint: 1,
  },
  addition: {
    upper: 999.9,
    lower: 0,
    decimalPoint: 1,
  },
  interest1: {
    upper: 99.9,
    lower: 0,
    decimalPoint: 1,
  },
  interest2: {
    upper: 99.9,
    lower: 0,
    decimalPoint: 1,
  },
  startAge: {
    upper: 99,
    lower: 0,
    decimalPoint: 0,
  },
  turningAddition: {
    upper: 999.9,
    lower: 0,
    decimalPoint: 1,
  },
  turningAge: {
    upper: 99,
    lower: 0,
    decimalPoint: 0,
  },
}

export const IframeCalcReversal: React.FC = () => {
  const dispatch = useDispatch()
  const { fetchState } = useSelector((state: AppState) => state.calcReversal)
  const [isShowGuide, setShowGuide] = useState(false)
  const [isShowDisclaimer, setShowDisclaimer] = useState(false)
  const [inputErrorMessage, setInputErrorMessage] = useState('')

  const resetInputErrorMessage = useCallback(() => setInputErrorMessage(''), [setInputErrorMessage])

  useHeadTitle('今こそ資産運用を考えよう', '取り崩しシミュレーション')
  useDescription(
    'シミュレーションを通じてご自身の資産運用を考えてみませんか。野村アセットマネジメントが資産運用に取り組む皆さまをサポートします。'
  )
  useEffect(() => {
    dispatch(reset())
    return () => {
      dispatch(reset())
    }
  }, [dispatch])

  useSendEmbedSizeInfo()

  const isPending = fetchState === 'pending'
  return (
    <React.Fragment>
      <main className="include torikuzushi">
        <section>
          <div className="c-title-wrap">
            <h2 className="c-title--primary">取り崩しシミュレーション</h2>
            <p className="c-title__lead">取り崩し額によって資産寿命はどう変わる？</p>
            <p className="u-text--right">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" className="c-title__link-info" onClick={() => setShowGuide(true)}>
                使い方ガイド
              </a>
            </p>
          </div>
          <div id="app-root" role="application">
            <div className="u-bg--white">
              <div className="l-container">
                <div className="p-simulation">
                  <div className="p-simulation__container">
                    <CalcReversalForm
                      setInputErrorMessage={setInputErrorMessage}
                      isPending={isPending}
                      isResponsive={true}
                    />
                    <Loading apiStatus={fetchState} />
                  </div>
                  <CalcReversalChart isResponsive={true} />
                  <div className="u-mt50px">
                    <p className="c-note">
                      将来の運用成果を示唆あるいは保証するものではありません。内容の正確性、完全性、適合性等を保証するものではありません。
                      当該情報の利用による投資等の損益はすべてお客さまに帰属し、野村アセットマネジメント株式会社は一切責任を負いません。
                      サービス内容、免責事項、利用する指数の情報など、詳細は
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                      <a href="#" onClick={() => setShowDisclaimer(true)}>
                        こちら
                      </a>
                      を御覧ください。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CalcReversalGuideModal isShow={isShowGuide} setShow={setShowGuide} />
          <DisclaimerModal isShow={isShowDisclaimer} setShow={setShowDisclaimer} />
          <CalcReversalErrorModal
            inputErrorMessage={inputErrorMessage}
            resetInputErrorMessage={resetInputErrorMessage}
          />
        </section>
        <div id="modal-root"></div>
      </main>
    </React.Fragment>
  )
}
